import type { FilterGroupTitle } from '~/models/Filter.models';

const filterGroupsToIncludeInQuery: FilterGroupTitle[] = [
  'Tillverkare',
  'Delbetalning',
  'Abonnemang',
  'Kategorier',
];

const filterGroupToQueryTranslationMap: { [key: string]: string } = {
  Tillverkare: 'vendor',
  Delbetalning: 'mp',
  Abonnemang: 'plan',
  Kategorier: 'cat',
};

export const formatSelectedFilterGroupTitleForQuery = (
  filterGroupTitle?: string,
) => {
  if (!filterGroupTitle) {
    return '';
  }

  return filterGroupToQueryTranslationMap[filterGroupTitle];
};

export const formatSelectedFilterValueForQuery = (filterValue?: string) => {
  return (filterValue || '')
    .toLowerCase()
    .replaceAll(' ', '-')
    .replaceAll('-mån', '')
    .replaceAll('-gb', '')
    .replaceAll('å', 'a')
    .replaceAll('ä', 'a')
    .replaceAll('ö', 'o');
};

export const readFilterQueryValueForFilterGroup = (
  filterGroupName?: FilterGroupTitle,
): string => {
  const { query } = useRoute();

  if (!filterGroupName) {
    return '';
  }

  const queryKey = filterGroupToQueryTranslationMap[filterGroupName];
  if (!queryKey) {
    return '';
  }

  if (!query[queryKey]) {
    return '';
  }

  return `${query[queryKey]}` || '';
};

export const buildFilterUrlQueryAfterToggle = () => {
  const filterStore = useFilterStore();

  const newQueryParamMap: { [key: string]: string } = {};

  const activeFiltersToMakeQueryParamsFor = Object.keys(
    filterStore.activeFilters,
  ).filter((key) =>
    filterGroupsToIncludeInQuery.includes(key as FilterGroupTitle),
  ) as FilterGroupTitle[];

  for (const filterGroupName of activeFiltersToMakeQueryParamsFor) {
    if (!filterStore.activeFilters[filterGroupName]) {
      continue;
    }

    const filter = filterStore.activeFilters[filterGroupName];
    const filterValues = Object.values(filter);
    if (filterValues.length === 0) {
      continue;
    }

    const queryKey = formatSelectedFilterGroupTitleForQuery(filterGroupName);
    const queryValue = formatSelectedFilterValueForQuery(
      filterValues.join(','),
    );

    newQueryParamMap[queryKey] = queryValue;
  }

  return newQueryParamMap;
};

export const updateQueryWithActiveFilters = () => {
  const route = useRoute();
  const router = useRouter();
  const { query } = useRoute();
  const filterStore = useFilterStore();
  const planStore = usePlanStore();

  const queryParamNamesForFilters = Object.values(
    filterGroupToQueryTranslationMap,
  );

  const otherQueryParamsNotRelatedToFilter = Object.fromEntries(
    Object.entries(query).filter(
      ([key]) => !queryParamNamesForFilters.includes(key),
    ),
  );

  const newQueryMap = buildFilterUrlQueryAfterToggle();

  const newFilterQueryParamsWithoutDefaultValues = Object.fromEntries(
    Object.entries(newQueryMap).filter(([key, value]) => {
      if (key === 'mp' && value === `${filterStore.defaultDownPayment}`) {
        return false;
      }

      if (key === 'plan') {
        const valueFormattedForMap = value.replaceAll('-', '');

        if (
          valueFormattedForMap in planStore.planAllowanceToPlanIdMapForFilter &&
          filterStore.defaultPlanId ===
            planStore.planAllowanceToPlanIdMapForFilter[valueFormattedForMap]
        ) {
          return false;
        }
      }

      return true;
    }),
  );

  router.replace({
    path: route.path,
    query: {
      ...otherQueryParamsNotRelatedToFilter,
      ...newFilterQueryParamsWithoutDefaultValues,
    },
  });
};
